<div class="drp">
  <div class="mt-1" *ngIf="params.from == 'technology'">
    <ng-select
      [ngModel]="this.processId == 0 ? null : this.processId"
      [bindValue]="bindValue"
      [clearable]="true"
      id="currentDropdown2"
      [clearOnBackspace]="false"
      class="dqa-drpdown"
      container="body"
      #select
      [items]="processList"
      [searchable]="false"
      [bindLabel]="bindLabel"
      [searchFn]="commonInputSearchForName"
      [placeholder]="placeHolder"
      (blur)="blurOut()"
      (focus)="focusOn()"
      (change)="updateValue($event)"
      (clear)="resetTValue()"
      [virtualScroll]="true"
    >
      <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
        <div
          *ngIf="bindLabel === 'description'"
          title="{{ item?.description }}"
          [ngOptionHighlight]="search"
        >
          {{ item?.description }}
        </div>
        <div *ngIf="bindLabel === 'name'" title="{{ item?.name }}" [ngOptionHighlight]="search">
          {{ item.name }}
        </div>
      </ng-template>
    </ng-select>
  </div>
  <div
    *ngIf="params.from == 'geography'"
    class="normaText"
    [ngStyle]="{ 'height.px': params.data.geography ? null : 22 }"
    title="{{ params.data.geography }}"
  >
    {{ params.data.geography }}
  </div>
  <div
    *ngIf="params.from == 'Temporal'"
    class="normaText"
    [ngStyle]="{ 'height.px': params.data.timePeriod ? null : 22 }"
  >
    {{ params.data.timePeriod }}
  </div>
  <div
    class="dataQualityAssessmentInput"
    [ngClass]="params.from != 'technology' ? 'inputMargin' : 'inputTechnologyMargin'"
  >
    <input
      class="form-control"
      [(ngModel)]="technologyComment"
      #inputDataQuality
      placeholder="Comment"
      (blur)="blurDataQuality(inputDataQuality, params.from)"
      type="text"
    />
  </div>
  <div class="dataProcessKey">
    <div class="d-flex gap-1 py-2 custom-pad-font" *ngIf="iconConfigs && iconConfigs.length">
      <i
        *ngFor="let iconConfig of iconConfigs"
        [id]="
          'dataAssessmentQualityTechnology' + params.from + params.rowIndex + '-' + iconConfig.value
        "
        [ngClass]="{
          'pointer-event': true,
          fa: true,
          'fa-circle': iconConfig.value == matchCircle,
          'fa-circle-thin': iconConfig.value != matchCircle
        }"
        [style.color]="iconConfig.color"
        style="cursor: pointer"
        [title]="iconConfig.title"
        (click)="handleIconClick($event, iconConfig.value)"
      >
      </i>
    </div>
  </div>
</div>
